module.exports = __webpack_public_path__ + "static/media/bgcLogin.bcbc9eb5.svg";